import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Button } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

class Navigation extends React.Component {
  handleKindChange = (_, { value }) => {
    this.props.changeReportKind(value);
  };

  handleTimespanChange = (_, { value }) => {
    this.props.changeReportTimespan(value);
  };

  render() {
    const { t } = this.props;

    return (
      <div className="container-header">
        <Button.Group basic>
          <Dropdown
            button
            value={this.props.kind}
            options={this.props.kindOptions?.map((k) => {
              return {
                ...k,
                text: t(`reports.${k.text}`),
              }
            })}
            onChange={this.handleKindChange}
            className={'report-dropdown'}
          />
          <Button
            icon="chevron left"
            onClick={this.props.moveReportDateBackwards}
          />
          <Dropdown
            basic
            button
            icon={false}
            text={this.props.timespanLabel}
            value={this.props.timespan}
            options={this.props.timespanOptions?.map((k) => {
              return {
                ...k,
                text: t(`reports.${k.text}`),
              }
            })}
            onChange={this.handleTimespanChange}
          />
          <Button
            icon="chevron right"
            onClick={this.props.moveReportDateForwards}
          />
        </Button.Group>
      </div>
    );
  }
}

Navigation.propTypes = {
  kind: PropTypes.string,
  kindOptions: PropTypes.array,
  timespan: PropTypes.string,
  timespanLabel: PropTypes.string,
  timespanOptions: PropTypes.array,
  changeReportKind: PropTypes.func,
  changeReportTimespan: PropTypes.func,
  moveReportDateBackwards: PropTypes.func,
  moveReportDateForwards: PropTypes.func
};

export default withTranslation() (Navigation);
